/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import styles from "./HomeGroup.module.scss";

import FormController from "../../../FormController/FormController";
import FormTitle from "../../../FormTitle/FormTitle";
import {
  adobeClickTracking,
  adobePageNameTracking,
} from "../../../../helpers/tracking";
import { setType } from "../../../../features/singleGroup/singleGroupSlice";

const HomeGroup = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { type } = useSelector((state) => state.singleGroup);
  useEffect(() => {
    if (!type) dispatch(setType("group"));
    // dispatch(setType("group"));
    adobePageNameTracking({
      pageName:
        "Washington Nationals: Tickets: Nationals Ticketfinder: Group Tickets Landing Page",
    });
  }, []);

  // if (!type) return <p>Loading ...</p>;

  return (
    <div className={styles.homeGroup}>
      <div className={styles.content}>
        <div className={styles.left}>
          {/* <img
            src={require(`../../../../assets/images/group-left.jpeg`)}
            alt=""
          /> */}
        </div>
        <div className={styles.right}>
          <FormTitle
            title="2025 Group Tickets, Luxury Suites & Experiences"
            style={{
              textAlign: "center",
              margin: 0,
              lineHeight: "30px",
              letterSpacing: 0,
            }}
          />
          <p className={styles.title}>
            Nationals games are the perfect event for companies, schools,
            non-profits, associations, and youth sports leagues. Reserving a
            group is easy, and a wide range of seating and pricing options is
            available, including luxury suites. Plus, you will get tons of great
            benefits:
          </p>
          <div className={styles.content_col}>
            <div className={styles.content_col_items}>
              <div className={styles.content_col_item}>
                <img
                  src={require(`../../../../assets/images/icons/icons-2.png`)}
                  alt=""
                />
                <span>
                  Discounted tickets for groups of 20 or more - the larger the
                  group, the larger the savings!
                </span>
              </div>
              {/* <div className={styles.content_col_item}>
                <img
                  src={require(`../../../../assets/images/icons/icons-3.png`)}
                  alt=""
                />
                <span>No per-ticket fees</span>
              </div> */}
              <div className={styles.content_col_item}>
                <img
                  src={require(`../../../../assets/images/icons/icons-1.png`)}
                  alt=""
                />
                <span>
                  Reserved seating, allowing your group to enjoy the game
                  together
                </span>
              </div>
            </div>
            <div className={styles.content_col_items}>
              <div className={styles.content_col_item}>
                <img
                  src={require(`../../../../assets/images/icons/icons-5.png`)}
                  alt=""
                />
                <span>
                  Pregame hospitality areas and meeting spaces available for
                  booking
                </span>
              </div>
              <div className={styles.content_col_item}>
                <img
                  src={require(`../../../../assets/images/icons/icons-4.png`)}
                  alt=""
                />
                <span>
                  Unique on-field experiences available to groups of 100 or
                  more, including pregame parade, pregame group photo opp, visit
                  from Screech, postgame catch on the field, and more!
                </span>
              </div>
            </div>
          </div>
          <div className={styles.buttons}>
            <div style={{ textAlign: "center" }}>
              <p className={styles.message}>
                2025 group tickets & luxury suites now available!
              </p>

              <p className={styles.footNote}>
                Groups of 20 or more can select their seats and complete their
                group booking directly through Nats TicketFinder!
                <br />A $10 processing fee will be added to all orders at
                checkout.
              </p>
              <div className={styles.btns}>
                <button
                  className={styles.greenButtonLarge}
                  onClick={() => {
                    history.push("/ticket-single-group");

                    adobeClickTracking({
                      prop13:
                        "Washington Nationals: Tickets: Nationals Ticketfinder: Group Tickets",
                      prop14:
                        "Large Group Tickets: I am ready to book my group outing Click",
                    });
                  }}
                >
                  I am ready to book my group outing
                </button>
              </div>
            </div>

            {/* <div>
                <button
                  className={styles.greenButton}
                  onClick={() => {
                    adobeClickTracking({
                      prop13:
                        "Washington Nationals: Tickets: Nationals Ticketfinder: Group Tickets",
                      prop14:
                        "Large Group Tickets: I Am Ready To Book My Luxury Suite Click",
                    });
                    window
                      .open(
                        "https://www.mlb.com/nationals/tickets/premium/luxury-suites#select-your-game",
                        "_blank"
                      )
                      .focus();
                  }}
                >
                  I AM READY TO BOOK MY LUXURY SUITE
                </button>
                <p className={styles.footNote}>
                  Online suite reservations now available!
                </p>
              </div> */}
            <div style={{ textAlign: "center" }}>
              <div>
                <button
                  className={styles.greenButton}
                  onClick={() => {
                    window.open(
                      "https://www.mlb.com/nationals/tickets/premium/luxury-suites#select-your-game",
                      "_blank"
                    );
                    adobeClickTracking({
                      prop13:
                        "Washington Nationals: Tickets: Nationals Ticketfinder: Group Tickets",
                      prop14:
                        "Large Group Tickets: I am ready to book my luxury suite",
                    });
                  }}
                >
                  I am ready to book my luxury suite
                </button>
                <p className={styles.footNote}>
                  Online suite reservations now available!
                </p>
              </div>
              <div>
                <button
                  className={styles.blueButton}
                  onClick={() => {
                    adobeClickTracking({
                      prop13:
                        "Washington Nationals: Tickets: Nationals Ticketfinder: Group Tickets",
                      prop14:
                        "Large Group Tickets: I Am Interested, But Need More Information Click",
                    });
                    window.chatBtn();
                  }}
                >
                  I am interested, but need more information
                </button>
                <p className={styles.footNote}>
                  Nationals Group Sales representatives are standing by during
                  normal business hours
                </p>
              </div>
            </div>
            <div style={{ textAlign: "center" }}>
              <button
                className={styles.blueButton}
                onClick={() => {
                  adobeClickTracking({
                    prop13:
                      "Washington Nationals: Tickets: Nationals Ticketfinder: Group Tickets",
                    prop14:
                      "Large Group Tickets: Off-hours? Let us get back to you Click",
                  });
                  window
                    .open(
                      "https://www.mlb.com/nationals/forms/request-more-information",
                      "_blank"
                    )
                    .focus();
                }}
              >
                Off-hours? Let us get back to you
              </button>
              <p className={styles.footNote}>
                If we’re not currently available to chat, leave us some
                information on your group event, so that we can get back to you
                ASAP
              </p>
            </div>
          </div>
        </div>
      </div>
      <FormController backTo="/" startOver="/" showBack showStartOver />
    </div>
  );
};

export default HomeGroup;

// width: 100vw;
// max-width: 1180px;
